<template>
  <div class="sinceubeengone" v-if="!important_only">
    <ul>
      <li
        class="mb-4"
        v-for="message in _advisor.new_messages.concat(_advisor.old_messages)"
      >
        <p class="title is-5 mb-1">
          {{ message.title }}
        </p>
        <p v-html="message.message"></p>
      </li>
    </ul>
  </div>
  <div v-else>
    <a
      href="#_"
      v-if="_advisor && _advisor.new_messages && _advisor.new_messages.length > 0"
      v-on:click="showDetail(_advisor.new_messages)"
    >
      <b-icon
        pack="fas"
        icon="bell"
        class="mr-3"
      />
    </a>
  </div>
</template>

<script>
  import DashboardMessageModal from '@frontend/dash3/js/components/DashboardMessageModal.vue';
  import DashboardTermsModal from '@frontend/dash3/js/components/DashboardTermsModal.vue';

  import Advisor from '@frontend/dash3/js/shared/Advisor.js';

  export default {
    data() {
      return {
        _advisor: {},
      }
    },
    props: {
      advisor: Object,
      important_only: {
        type: Boolean,
        default: true,
      },
    },
    components: {
      DashboardMessageModal,
      DashboardTermsModal,
    },
    methods: {
      showDetail: function(messages) {
        this.$buefy.modal.open({
          parent: this,
          component: DashboardMessageModal,
          hasModalCard: true,
          trapFocus: true,
          props: {
            messages: messages,
          }
        });
      },
      showTerms: function() {
        this.$buefy.modal.open({
          parent: this,
          component: DashboardTermsModal,
          hasModalCard: true,
          trapFocus: true,
          canCancel: false,
        });
      },
      showFAFNTerms: function() {
        this.$buefy.modal.open({
          parent: this,
          component: FAFNDashboardTermsModal,
          hasModalCard: true,
          trapFocus: true,
          canCancel: false,
        });
      },
    },
    computed: {},
    created: function() {
      // This can either receive the advisor via props from a parent component or be used bare in the html
      // and instantiate an advisor from the <script> bootstrap on its own.
      this.$root.$data.csrfToken = document.querySelector('[name="csrfmiddlewaretoken"]').value;

      if (!this.advisor) {
        this._advisor = new Advisor();
      }
      else {
        this._advisor = this.advisor;
      }
      this.$root.advisor = this._advisor;

      if (this._advisor.terms_agreement_required) {
        this.showTerms();
      }

      if (this._advisor.new_messages && this.important_only) {
        const importantMessages = this._advisor.new_messages.filter((itm) => { return itm.important });
        if (importantMessages.length > 0) {
          this.showDetail(importantMessages);
        }
      }
    },
  }
</script>

<style lang="scss">

</style>
